import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import type { IconProps } from '../../primitives/types.js';

/** Lowercase Greek theta (θ) — vertical oval with a horizontal cross
 *  bar through the middle. The most common math glyph for an angle in
 *  trigonometry. */
export function IcnTheta(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="theta">
      <ellipse cx="8" cy="8" rx="3.5" ry="5.5" />
      <path d="M5 8 H11" />
    </Svg>
  );
}
